import type { TFunction } from "i18next";
import U2000SaveCancelDialog from "../../../../../u2000Core/components/dialog/U2000SaveCancelDialog";
import U2000ComboBoxBase from "../../../../../u2000Core/components/formControls/combobox/U2000ComboBoxBase";
import { U2000FormStateEnumEditMode } from "../../../../../u2000Core/reducer/formReducer/U2000FormState";
import type { U2103UserActionHandler } from "./U2103UserActionHandlers";
import type { U2103LogicalUnit, U2103LogicalUnitAction } from "../../../../U2103Service";

// Typage des props du composant
interface U2103UserActionDlgProps {
  u2103UserActionHandler: U2103UserActionHandler;
  t: TFunction;
  NS: string;
}

// Composant pour le dialogue d'édition des actions d'une unité logique
function U2103UserActionEditDlg({ u2103UserActionHandler, t, NS }: U2103UserActionDlgProps) {
  const { formStateHandlers } = u2103UserActionHandler;

  // Unified handler that manages Save and Cancel differently
  const handleClose = (action: "save" | "cancel") => {
    if (action === "cancel") {
      // Temporarily disable onBlur validation to prevent unwanted validation on cancel
      const originalOnBlur = formStateHandlers.onBlur;
      formStateHandlers.onBlur = () => {
        /* Ignore onBlur during cancel */
      };

      // Close dialog immediately without validation
      u2103UserActionHandler.onDlgClose("cancel");

      // Restore original onBlur handler after dialog closes
      setTimeout(() => {
        formStateHandlers.onBlur = originalOnBlur;
      }, 0);
    } else if (action === "save") {
      // Normal save flow with validation
      u2103UserActionHandler.onDlgClose("save");
    }
  };

  const filteredLogicalUnitActions = u2103UserActionHandler.logicalUnits.filter(
    (lu) => !u2103UserActionHandler.gridLogicalUnitCodes.includes(lu.logicalUnitCode) || (formStateHandlers.getData() && lu.logicalUnitCode === formStateHandlers.getData().logicalUnitCode),
  );

  // renmder
  return (
    <U2000SaveCancelDialog width="w-[700px]" height="h-[700px]" isOpen={u2103UserActionHandler.isDialogOpen} onClose={handleClose} title={t("lblLogicalUnitAction", { ns: NS })} isValid={true}>
      <div className="flex flex-col gap-y-4">
        <U2000ComboBoxBase<U2103LogicalUnit>
          data={filteredLogicalUnitActions}
          keyField="id"
          descField="logicalUnitDescription"
          onChangeObject={(field) => u2103UserActionHandler.onLogicalUnitChangeObject(field)}
          value={u2103UserActionHandler.formStateHandlers.getData() as U2103LogicalUnit}
          disabled={u2103UserActionHandler.formStateHandlers.getFormEditMode() === U2000FormStateEnumEditMode.EDIT}
        />

        {u2103UserActionHandler.logicalUnitActions &&
          u2103UserActionHandler.logicalUnitActions.map((action: U2103LogicalUnitAction, index) => (
            <div key={index} className="mb-1 flex items-center gap-x-2">
              <div
                className={`h-6 w-6 cursor-pointer rounded-sm border-2 transition-colors duration-300 ${action.idChecked ? "border-blue-500 bg-blue-100" : "border-gray-300 bg-white"}`}
                onClick={() => u2103UserActionHandler.onCheckLogicalUnitAction(action)}
              >
                {action.idChecked && (
                  <svg className="m-auto h-5 w-5 text-black" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                    <path d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
              <p className="inline-block text-gray-800">
                {action.logicalUnitActionCode} - {action.logicalUnitActionDescription}
              </p>
            </div>
          ))}
      </div>
    </U2000SaveCancelDialog>
  );
}

export default U2103UserActionEditDlg;
